import React from 'react';
import { Seg } from 'shared/ui/Seg';
import { useSizingMode } from './useSizingMode';

const OPTIONS = [{ value: 'nodeCount', label: 'Node Count' }, { value: 'capacity', label: 'Raw Capacity' }];

/** Node Count / Raw Capacity. One setting that governs both storage sets, so it
 *  belongs to neither: classic puts it in the header of the card that holds both
 *  columns. Here it is the bare control, and the shell places it in the rail's
 *  stat block beside the PB / PiB switch (features do not import each other, so
 *  AppShell hands it to LiveRail as a slot). */
export function SizingModeToggle() {
  const s = useSizingMode();
  return <Seg ariaLabel="Size the system by" value={s.sizeBy} onChange={s.onSizeByChange} options={OPTIONS} />;
}
